import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.75 2c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v20c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25V2Zm12.5 0c0-.69.56-1.25 1.25-1.25H21c.69 0 1.25.56 1.25 1.25v20c0 .69-.56 1.25-1.25 1.25h-5.5c-.69 0-1.25-.56-1.25-1.25V2Z",
		stroke: "#262626",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M1.75%202c0-.69.56-1.25%201.25-1.25h5.5c.69%200%201.25.56%201.25%201.25v20c0%20.69-.56%201.25-1.25%201.25H3c-.69%200-1.25-.56-1.25-1.25V2Zm12.5%200c0-.69.56-1.25%201.25-1.25H21c.69%200%201.25.56%201.25%201.25v20c0%20.69-.56%201.25-1.25%201.25h-5.5c-.69%200-1.25-.56-1.25-1.25V2Z%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
